export default __webpack_public_path__ + "static/media/banner_blue.b3b25129.png";